import { IUserProps } from "./User";

/** Admin list/detail payloads may use Mongo `_id` instead of `id`. */
export function squadApiId(squad: {
  id?: string;
  _id?: string;
}): string | undefined {
  if (squad.id) return squad.id;
  if (squad._id != null) return String(squad._id);
  return undefined;
}

export interface ISquadProps {
  id: string;
  name: string;
  description?: string;
  inviteCode: string;
  creator: string | IUserProps;
  membersCount: number;
  status: "active" | "disbanded";
  createdAt: string;
  updatedAt: string;
  /** Current-epoch total from squad points ledger (admin list) */
  squadPointsTotal?: number;
  squadPointsEpoch?: number;
  memberCount?: number;
  pendingInviteCount?: number;
}

export interface ISquadMemberProps {
  id: string;
  squad: string | ISquadProps;
  user: IUserProps;
  role: "leader" | "member";
  joinedAt: string;
  /** present on API rows (active / pending_admin_approval / pending_user_acceptance) */
  status?: string;
  /** Sum of squad point deltas for this membership row (current epoch) */
  squadPointsContribution?: number;
}

export type SquadMembershipHistoryEventType =
  | "joined"
  | "join_request_submitted"
  | "join_request_rejected"
  | "invite_sent"
  | "invite_withdrawn"
  | "join_request_withdrawn"
  | "left"
  | "removed_by_admin"
  | "removed_by_leader"
  | "squad_disbanded";

export interface ISquadMembershipHistoryEntryProps {
  id: string;
  type: SquadMembershipHistoryEventType;
  createdAt: string;
  user: IUserProps | null;
  actorUser?: IUserProps | null;
  actorAdminId?: string | null;
  role?: "leader" | "member";
}

export interface ISquadLedgerEntryProps {
  _id?: string;
  delta: number;
  kind: "mission_complete" | "mission_revoke";
  weekKey: string;
  squadPointsEpoch?: number;
  membershipId?: string | null;
  createdAt?: string;
  userId?: IUserProps | { _id?: string; firstName?: string; lastName?: string; email?: string };
  missionId?: { _id?: string; title?: string } | null;
}

export interface ISquadDetailsProps extends ISquadProps {
  members: ISquadMemberProps[];
  membershipHistory?: ISquadMembershipHistoryEntryProps[];
  recentPointsLedger?: ISquadLedgerEntryProps[];
}
